import React, { useEffect, useState } from "react";
import CopyrightComponent from "../component/CopyrightComponent";
import { useNavigate } from "react-router-dom";
import ApiService from "../utils/ApiService";
import { ConfigProvider, Spin, Image, Space, Input, message } from "antd";
import { storeOtpVerifyObj, validatePhoneNumber } from "../utils/Common";

function ForgetPassword() {
  const [apiCalling, setApiCalling] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [payload, setPayload] = useState({
    countryCode: "880",
    phone: "",
  });
  const [formPosition, setFormPosition] = useState({
    marginTop: "50px",
  });

  useEffect(() => {
    calculateCenter();
  }, []);

  const calculateCenter = () => {
    const loginFormHeight = document.getElementById("login-form").offsetHeight;
    const mainFormHeight = document.getElementById("main-form").offsetHeight;
    let freeHeight = (mainFormHeight - loginFormHeight) / 3;
    setFormPosition({
      marginTop: `${freeHeight}px`,
    });
  };

  const goToLogin = () => {
    navigate("/");
  };

  const goBack = () => {
    navigate("/login");
  };

  const goOtp = async () => {
    if (payload.phone == "") {
      setError("Phone number required");
      return;
    }

    if (!validatePhoneNumber(payload.phone)) {
      setError("Invalid phone.");
      return;
    }

    setApiCalling(true);
    const res = await ApiService.FORGOT_PASSWORD(payload);

    setApiCalling(false);

    if (res.code !== 200) {
      setError(res.message);
      return;
    }
    
    storeOtpVerifyObj(payload.phone);

    message.success("OTP has been sent to your phone.");
    navigate("/otp");
  };

  const updatePhone = (e) => {
    const val = e.target.value;

    if (val.length <= 11 && /^\d*$/.test(val)) {
      setPayload({
        ...payload,
        phone: val,
      });
      setError("");
    }
  };

  return (
    <div
      id="main-form"
      style={{ height: "100vh" }}
      className="flex flex-col items-center p-[50px] bg-yellow"
    >
      <div
        id="login-form"
        style={formPosition}
        className="flex w-[360px] flex-col lg:w-[400px] bg-white justify-center border-[1px] border-gray-300 rounded-[5px] p-[20px]"
      >
        <div
          className="flex mb-[10px] items-center justify-center gap-x-[20px]"
          onClick={goToLogin}
        >
          <Image
            src={`/images/icons/TableTap_icon.svg`}
            preview={false}
            alt="tabletap"
            className="w-[96px] h-[96px]"
          />
          <div className="text-2xl font-bold text-red-600 font-ubold pb-[10px] content-center">
            <Image
              src={`/images/Scan_Order_Savor.png`}
              preview={false}
              alt="scan_order_savor"
              className="pt-[10px]"
            />
          </div>
        </div>
        <div className="text-red-700 ml-[20px] py-[8px] flex flex-col font-regular text-sm cursor-pointer">
          {error}
        </div>

        <div className="w-full flex flex-col pl-[16px] mb-[12px] text-sm">
          <div>
            Phone <span className="text-red-600 font-bold">*</span>
          </div>
          <div className="w-full">
            <Space.Compact className="w-full">
              <Input
                readOnly={true}
                style={{
                  width: "75px",
                }}
                defaultValue="+880"
              />
              <Input
                value={payload.phone}
                onPressEnter={goOtp}
                onChange={updatePhone}
                placeholder="e.g. 1715XXXXXX"
              />
            </Space.Compact>
          </div>
        </div>

        <div className="flex flex-row px-[16px] mt-[8px] items-center">
          {apiCalling ? (
            <div className="w-[90px] text-center">
              <ConfigProvider
                theme={{
                  components: {
                    Spin: {
                      colorPrimary: "#EE3169",
                    },
                  },
                }}
              >
                <Spin
                  size="medium"
                  className="w-[66px]text-center items-center"
                />
              </ConfigProvider>
            </div>
          ) : (
            <div
              className="bg-yellow text-black px-[12px] py-[8px] rounded-[5px] font-ubold cursor-pointer"
              onClick={goOtp}
            >
              Request
            </div>
          )}
          <div
            className="text-black px-[12px] py-[8px] font-ulight underline cursor-pointer"
            onClick={goBack}
          >
            Go Back
          </div>
        </div>
      </div>
      <CopyrightComponent />
    </div>
  );
}

export default ForgetPassword;
